import { Link } from "react-router-dom";
import { siteInfo, testimonials } from "@/mocks/news";

export default function BrandSection() {
  return (
    <section className="mx-auto max-w-site px-4 py-14 md:px-6 md:py-16" aria-labelledby="brand-title">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <p className="text-xs font-medium tracking-[0.2em] text-primary-600">ABOUT US</p>
          <h2 id="brand-title" className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            关于看瓜爆料
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-700">
            看瓜爆料是一个专注娱乐热点的资讯门户。我们不做夸张的标题党，而是把散落各处的公开信息按照时间线整理清楚，
            让你在几分钟内就能弄明白一件事的来龙去脉。
          </p>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            编辑部坚持三件事：标明信息来源、区分传闻与官方说法、事件有进展就及时更新。
            热榜只反映当下讨论热度，不代表我们对事件本身的判断。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              查看品牌介绍
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
            <a
              href={`mailto:${siteInfo.contactEmail}`}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-6 py-3 text-sm font-bold text-foreground-800 transition-colors hover:border-accent-500 hover:text-accent-800"
            >
              <i className="ri-mail-send-line" aria-hidden="true"></i>
              提交线索
            </a>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {testimonials.map((item, index) => (
              <figure
                key={item.name}
                className={`rounded-lg border border-background-200 p-5 ${
                  index % 2 === 0 ? "bg-secondary-50" : "bg-background-50"
                }`}
              >
                <div className="flex items-center gap-1 text-secondary-600">
                  {[0, 1, 2, 3, 4].map((star) => (
                    <i key={star} className="ri-star-fill text-sm" aria-hidden="true"></i>
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                  {item.text}
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-2.5">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                    {item.name.slice(0, 1)}
                  </span>
                  <span className="text-xs">
                    <span className="block font-medium text-foreground-900">{item.name}</span>
                    <span className="text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}